import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ManualVoucherApprovalItemsTable } from '@/entities/manual-voucher-approval'

export const Route = createFileRoute(
  '/_auth/applications/manual-voucher-approval/$manualVoucherId/items'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <ManualVoucherApprovalItemsTable />
      <Outlet />
    </>
  )
}
